import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { IInsuranceV2 } from 'interfaces/insurance';

const name = 'insurancesV2';

export const fetchInsurancesV2 = createAsyncThunk(`${name}/fetch`, async (organizationId: string, { dispatch }) => {
  try {
    const { data } = await axios.get<IInsuranceV2[]>(`/api/v3/organizations/${organizationId}/insurances`);
    return data;
  } catch (error) {
    dispatch(enqueueRequestErrorSnackbar());
    throw error;
  }
});

export type State = CommonState & {
  insurancesV2: IInsuranceV2[];
};

const initialState: State = {
  insurancesV2: [],
  isFetching: false,
  error: null
};

const insurancesV2 = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchInsurancesV2.pending, isFetching)
      .addCase(fetchInsurancesV2.fulfilled, (state, action) => {
        state.insurancesV2 = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchInsurancesV2.rejected, error);
  }
});

export const { reducer: insurancesV2Reducer } = insurancesV2;
